import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import { Avatar, Flex, HStack, Image, Stack, Text } from "@chakra-ui/react";
import { Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";

import { useLogoutMutation } from "redux/services/apiService";
import { useGetConfigsQuery } from "redux/services/config";
import {
  isUserAuthenticated,
  selectUserPermissions,
  selectUserRole,
} from "redux/slices/user";
import { useAppSelector } from "redux/store";

import User from "components/User/User";
import { ROUTE } from "utils/constants";
type Props = {};
const Header: React.FC<Props> = (): JSX.Element => {
  const { t, i18n } = useTranslation("common");
  const navigate = useNavigate();

  const isAuthenticated = useAppSelector(isUserAuthenticated);

  const selectPermission = useAppSelector(selectUserPermissions);

  const selectRole = useAppSelector(selectUserRole);

  const [logout] = useLogoutMutation();

  const { data: config } = useGetConfigsQuery();

  const handleLogout = async () => {
    await logout();
    navigate(`/login`);
  };

  const handleChangeLanguage = () => {
    i18n.changeLanguage(i18n.language === "en" ? "id" : "en");
  };

  const viewPermission = (permission) => {
    return selectPermission.some((p) => p === permission);
  };

  return (
    <Flex
      bgColor="#fff"
      alignItems="center"
      px="9"
      py="4"
      justifyContent="space-between"
    >
      <Flex alignItems="center">
        {/* <Image src={require("../../../assets/images/logo.png")} w="10" mr="4" /> */}
        {config?.data[0]?.site_logo ? (
          <Image
            src={
              process.env.REACT_APP_API_URL + "/" + config?.data[0]?.site_logo
            }
            w="10"
            mr="4"
          />
        ) : null}

        <Stack spacing={0}>
          <Text fontWeight="semibold" color={"#5B5B5B"} mb="0">
            {config?.data[0]?.site_title}
          </Text>
          <Text fontWeight="semibold">{config?.data[0]?.site_desc}</Text>
        </Stack>
      </Flex>

      <Flex>
        <HStack align="center" spacing={4}>
          {isAuthenticated && <User />}
          {isAuthenticated && (
            <Menu>
              <MenuButton
                as={Avatar}
                cursor="pointer"
                borderRadius={10}
                variant="outline"
                zIndex={100}
              />
              <MenuList zIndex={100}>
                <MenuItem onClick={handleChangeLanguage}>
                  {t("change_language")}
                </MenuItem>
                <MenuItem hidden={!viewPermission("view.menus")}>
                  <Link to={ROUTE.MENU_SETTING.LIST}>{t("menu_menu")}</Link>
                </MenuItem>
                <MenuItem hidden={!viewPermission("view.users")}>
                  <Link to={ROUTE.USER_SETTING.LIST}>{t("menu_user")}</Link>
                </MenuItem>
                <MenuItem hidden={selectRole !== "super-admin" && selectRole !== "super admin"}>
                  <Link to={ROUTE.ROLE_SETTING.LIST}>{t("menu_role")}</Link>
                </MenuItem>
                {/* <MenuItem hidden={selectRole !== "super-admin"}>
                  <Link to={ROUTE.PERMISSION_SETTING.LIST}>
                    {t("menu_permission")}
                  </Link>
                </MenuItem> */}
                <MenuItem hidden={selectRole !== "super-admin" && selectRole !== "super admin"}>
                  <Link to={`${ROUTE.CONFIG_SETTING.EDIT}/1`}>
                    {t("menu_config")}
                  </Link>
                </MenuItem>
                <MenuItem onClick={handleLogout}>{t("logout")}</MenuItem>
              </MenuList>
            </Menu>
          )}
        </HStack>
      </Flex>
    </Flex>
  );
};

export default Header;
